/** Страны СНГ и правила документов/телефона водителя (зеркало erp-backend cis_driver.py). */

export const CIS_COUNTRIES = [
  { code: 'AZ', label: 'Азербайджан' },
  { code: 'AM', label: 'Армения' },
  { code: 'BY', label: 'Беларусь' },
  { code: 'KZ', label: 'Казахстан' },
  { code: 'KG', label: 'Кыргызстан (Киргизия)' },
  { code: 'RU', label: 'Россия' },
  { code: 'TJ', label: 'Таджикистан' },
  { code: 'TM', label: 'Туркменистан' },
  { code: 'UZ', label: 'Узбекистан' },
]

const PHONE = {
  RU: { cc: '7', nationalLen: 10, nationalRe: /^9\d{9}$/, hint: 'Телефон РФ: +7 и 10 цифр (мобильный начинается с 9)' },
  KZ: { cc: '7', nationalLen: 10, nationalRe: /^[67]\d{9}$/, hint: 'Телефон Казахстана: +7 и 10 цифр (мобильный 6… или 7…)' },
  BY: { cc: '375', nationalLen: 9, nationalRe: /^\d{9}$/, hint: 'Телефон Беларуси: +375 и 9 цифр' },
  AM: { cc: '374', nationalLen: 8, nationalRe: /^\d{8}$/, hint: 'Телефон Армении: +374 и 8 цифр' },
  AZ: { cc: '994', nationalLen: 9, nationalRe: /^\d{9}$/, hint: 'Телефон Азербайджана: +994 и 9 цифр' },
  KG: { cc: '996', nationalLen: 9, nationalRe: /^\d{9}$/, hint: 'Телефон Кыргызстана: +996 и 9 цифр' },
  TJ: { cc: '992', nationalLen: 9, nationalRe: /^\d{9}$/, hint: 'Телефон Таджикистана: +992 и 9 цифр' },
  TM: { cc: '993', nationalLen: 8, nationalRe: /^\d{8}$/, hint: 'Телефон Туркменистана: +993 и 8 цифр' },
  UZ: { cc: '998', nationalLen: 9, nationalRe: /^\d{9}$/, hint: 'Телефон Узбекистана: +998 и 9 цифр' },
}

const RU_PHONE_OR = 'либо +7 и 10 цифр РФ (мобильный начинается с 9)'

const PASSPORT = {
  RU: [/^\d{10}$/, 'Паспорт РФ: 4 цифры серии и 6 цифр номера'],
  BY: [/^[A-Z]{2}\d{7}$/, 'Паспорт РБ: 2 латинские буквы и 7 цифр'],
  KZ: [/^(?:\d{9}|N\d{8})$/, 'Удостоверение РК: 9 цифр или N и 8 цифр'],
  AM: [/^[A-Z]{2}\d{7}$/, 'Паспорт Армении: 2 латинские буквы и 7 цифр'],
  AZ: [/^(?:\d{9}|[A-Z]{1,3}\d{7})$/, 'Паспорт Азербайджана: 9 цифр или буквы и 7 цифр'],
  KG: [/^[A-Z]{2}\d{7}$/, 'Паспорт Кыргызстана: 2 латинские буквы и 7 цифр'],
  TJ: [/^[A-Z]\d{8}$/, 'Паспорт Таджикистана: 1 латинская буква и 8 цифр'],
  TM: [/^[A-Z]\d{8}$/, 'Паспорт Туркменистана: 1 латинская буква и 8 цифр'],
  UZ: [/^[A-Z]{2}\d{7}$/, 'Паспорт Узбекистана: 2 латинские буквы и 7 цифр'],
}

const LICENSE = {
  RU: [/^[A-ZА-ЯЁ0-9]{9,10}$/i, 'ВУ РФ: 9 или 10 символов (цифры/буквы)'],
  BY: [/^[A-ZА-ЯЁ0-9]{8,10}$/i, 'ВУ Беларуси: 8–10 символов'],
  KZ: [/^[A-ZА-ЯЁ0-9]{8,10}$/i, 'ВУ Казахстана: 8–10 символов'],
  AM: [/^[A-Z0-9]{8,10}$/i, 'ВУ Армении: 8–10 символов'],
  AZ: [/^[A-Z0-9]{8,10}$/i, 'ВУ Азербайджана: 8–10 символов'],
  KG: [/^[A-Z0-9]{8,10}$/i, 'ВУ Кыргызстана: 8–10 символов'],
  TJ: [/^[A-Z0-9]{8,10}$/i, 'ВУ Таджикистана: 8–10 символов'],
  TM: [/^[A-Z0-9]{8,10}$/i, 'ВУ Туркменистана: 8–10 символов'],
  UZ: [/^[A-Z0-9]{8,10}$/i, 'ВУ Узбекистана: 8–10 символов'],
}

const isEmpty = (value) => value == null || (typeof value === 'string' && value.trim() === '')

const alnumUpper = (value) => String(value).replace(/[^0-9A-Za-zА-Яа-яЁё]/g, '').toUpperCase()

export function parseCisCountry(value) {
  const raw = String(value || '').trim().toUpperCase()
  return CIS_COUNTRIES.some((item) => item.code === raw) ? raw : null
}

export function passportByCountry(value, country) {
  if (isEmpty(value)) return true
  const code = parseCisCountry(country)
  if (!code) return 'Укажите страну водителя'
  const [re, message] = PASSPORT[code]
  return re.test(alnumUpper(value)) || message
}

export function licenseByCountry(value, country) {
  if (isEmpty(value)) return true
  const code = parseCisCountry(country)
  if (!code) return 'Укажите страну водителя'
  const [re, message] = LICENSE[code]
  return re.test(alnumUpper(value)) || message
}

function matchCountryPhone(digits, code) {
  const spec = PHONE[code]
  let work = digits
  if ((code === 'RU' || code === 'KZ') && work.length === 11 && work.startsWith('8')) {
    work = `7${work.slice(1)}`
  }
  if (code === 'RU' && work.length === 10 && work.startsWith('9')) {
    work = `7${work}`
  }
  let national
  if (work.startsWith(spec.cc) && work.length === spec.cc.length + spec.nationalLen) {
    national = work.slice(spec.cc.length)
  } else if (work.length === spec.nationalLen) {
    national = work
  } else {
    return false
  }
  return spec.nationalRe.test(national)
}

export function phoneByCountry(value, country) {
  if (isEmpty(value)) return true
  const code = parseCisCountry(country)
  if (!code) return 'Укажите страну водителя'
  let digits = String(value).replace(/\D/g, '')
  if (digits.startsWith('00')) digits = digits.slice(2)
  if (matchCountryPhone(digits, code)) return true
  if (code !== 'RU' && matchCountryPhone(digits, 'RU')) return true
  return countryHint(code)
}

export function countryHint(country) {
  const code = parseCisCountry(country)
  if (!code) return ''
  const local = PHONE[code].hint
  return code === 'RU' ? local : `${local}, ${RU_PHONE_OR}`
}
